import {
  buildQuadraticShapePath,
  convertSvgPathToEditableGeometry,
  getQuadraticShapeBounds,
} from "@/helpers/masterplan/curvedLotShape";

describe("curved lot shapes", () => {
  const points = [
    { x: 0, y: 0 },
    { x: 10, y: 0 },
    { x: 10, y: 10 },
    { x: 0, y: 10 },
  ];

  it("builds a quadratic edge through the draggable curve point", () => {
    const path = buildQuadraticShapePath(points, [
      { edgeIndex: 0, x: 5, y: -5 },
    ]);

    expect(path).toContain("Q5 -10 10 0");
    expect(
      getQuadraticShapeBounds(points, [{ edgeIndex: 0, x: 5, y: -5 }])
    ).toEqual({ x: 0, y: -5, width: 10, height: 15 });
  });

  it("converts an imported cubic curve into an editable single-handle edge", () => {
    const geometry = convertSvgPathToEditableGeometry(
      "M0 0C0 10 10 10 10 0L10 10L0 10L0 0Z",
      0.1
    );

    expect(geometry?.points).toEqual(points);
    expect(geometry?.curvePoints).toEqual([{ edgeIndex: 0, x: 5, y: 7.5 }]);
  });

  it("converts an imported arc into an editable single-handle edge", () => {
    const geometry = convertSvgPathToEditableGeometry(
      "M0 0A10 10 0 0 1 20 0L20 20L0 20Z",
      0.1
    );

    expect(geometry?.curvePoints).toHaveLength(1);
    expect(geometry?.curvePoints[0].x).toBeCloseTo(10);
    expect(Math.abs(geometry?.curvePoints[0].y ?? 0)).toBeCloseTo(10);
  });
});
